import ContentHighlights from './ContentHighlights';

export default ContentHighlights;
